module.exports = __webpack_public_path__ + "img/19.57918cc5.jpg";